import React from 'react';
import { Card, Form, Row, Col, Button, Modal, Select } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'dva';
import helpers from '../../../utils/helpers';
import styles from '../styles.less';

class LeadDetailsCard extends React.Component {
  onLeadMarkSelect(values) {
    const leadId = this.props.leadId;
    const projectId = this.props.projectId;

    this.props.dispatch({
      type: 'leads/assignLeadMarks',
      payload: {
        projectId,
        leadId,
        lead_marks: values,
      },
    });
  }

  getEmployeesRange(from, to) {
    let result = '';
    if (!from && !to) {
      result = this.props.intl.formatMessage({ id: 'Common.Unknown' });
    } else if (from && !to) {
      result = `> ${from}`;
    } else if (!from && to) {
      result = `< ${to}`;
    } else {
      result = `${from} - ${to}`;
    }

    return result;
  }

  info(data) {
    Modal.info({
      title: false,
      content: (
        <div>
          {data.map((item, i) =>
            <div className="text" key={`cc${i}`}> - {item.label}</div>)
          }
        </div>
      ),
      closable: false,
      wrapClassName: 'modal-info',
    });
  }

  renderBranches(data) {
    return (
      <div className="branches-wrap">
        {data && data.slice(0, 6).map((item, i) => (
          <div className="text" key={`cc${i}`}>{item.label}</div>
        ))}
        {data && data.length > 6 &&
          <Button type="default" onClick={() => this.info(data)}>
            <FormattedMessage id="Component.LeadDetails.ShowAll" />
          </Button>}
      </div>
    );
  }

  render() {
    const company = this.props.matomo ? this.props.matomo.leadDetails : null;
    // its failed each first open, when no state....
    if (!company) {
      return null;
    }

    const { getFieldDecorator } = this.props.form;
    const { leadLabelsList } = this.props.leadLabels;
    const { brancheTitle, toShow, showCB } = this.props;
    const custom = helpers.getUniqueCustomBranches(company.classification_codes);
    const compassBranches = [...new Set(company.classification_codes)];

    return (
      company &&
      <Card className="card-multiple">
        <Row type="flex" gutter={{ xs: 8, sm: 16, md: 24 }}>

          <Col xxl={6} xl={8} lg={10} md={24} sm={24} xs={24} style={{ marginTop: '10px' }}>
            <h3>{company.company_name}</h3>
          </Col>

          <Col xxl={6} xl={8} lg={10} md={24} sm={24} xs={24}>
            <h5><FormattedMessage id="Component.LeadDetails.Address" /></h5>
            <div className="text">{company.street}</div>
            <div className="text">{company.zip_code} {company.city}</div>
            <div className="text">{company.country && company.country.name}</div>
          </Col>

          <Col xxl={6} xl={8} lg={10} md={24} sm={24} xs={24}>
            <h5><FormattedMessage id="Component.LeadDetails.Website" /></h5>
            {company.websites.length > 0 && company.websites.map((w, i) => (
              <div key={i}><a className="link" href={w} target="_blank" rel="noopener noreferrer">{w}</a></div>
            ))}
            {company.websites.length === 0 && <div className="text">
              <FormattedMessage id="Common.Unknown" />
            </div>}
          </Col>

          <Col xxl={4} xl={6} lg={10} md={24} sm={24} xs={24}>
            <h5><FormattedMessage id="Component.LeadDetails.EmployeesCount" /></h5>
            <div className="text">
              {this.getEmployeesRange(company.employees_count_from, company.employees_count_to)}</div>
          </Col>

          <Col xxl={4} xl={6} lg={10} md={24} sm={24} xs={24}>
            <h5><FormattedMessage id="Component.LeadDetails.VisitsCount" /></h5>
            <div>{company.number_of_visits}</div>
          </Col>

          <Col xxl={4} xl={6} lg={10} md={24} sm={24} xs={24}>
            <h5><FormattedMessage id="Component.LeadDetails.SocialMedia" /></h5>
            <div>
              {company.social_links && company.social_links.map((s, i) => (
                <a
                  href={s.url}
                  key={i}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={[styles.socialMediaIcon, styles[`icon-${s.type.toLowerCase()}`]].join(' ')} />
                </a>
              ))}
            </div>
          </Col>

          <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
            <h5>{brancheTitle || <FormattedMessage id="Component.LeadDetails.BranchOfIndustry" />}</h5>
            {toShow && showCB ?
              this.renderBranches(custom) :
              this.renderBranches(compassBranches)
            }
          </Col>

        </Row>
        <hr />
        <Row type="flex" align="middle">
          <Col span={2} className="col">
            <FormattedMessage id="Component.LeadDetails.LeadMarks" />
          </Col>
          <Col span={22} className="col">
            <div>
              {company.lead_marks && getFieldDecorator('lead_marks', {
                initialValue: company.lead_marks.map(l => l.id),
              })(
                <Select
                  style={{ width: '100%' }}
                  showArrow
                  mode="multiple"
                  placeholder={(<FormattedMessage id="Component.LeadDetails.SetMarks" />)}
                  filterOption={helpers.multipleSelectFilter}
                  onChange={this.onLeadMarkSelect.bind(this)}
                >
                  {leadLabelsList && leadLabelsList.map(
                    lm => <Select.Option key={lm.id} value={lm.id}>{lm.name}</Select.Option>,
                  )}
                </Select>,
              )}
            </div>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default connect(({ matomo, leadLabels }) => ({
  matomo,
  leadLabels,
}))(Form.create()(injectIntl(LeadDetailsCard)));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadDetailsCard/LeadDetailsCard.js